// The time on an embed (#310): the date and the time the post was made, in the viewer's time zone and clock, like
// "Oct 27, 2026, 3:42 PM". Every client draws the same parts: abbreviated month, day, year, hour and minute.

const parts: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" };
const here = new Intl.DateTimeFormat(undefined, parts);

/** `locale` and `timeZone` are for tests; the app uses the viewer's. */
export function formatEmbedTime(ts: number, locale?: string, timeZone?: string): string {
  return (locale || timeZone ? new Intl.DateTimeFormat(locale, { ...parts, timeZone }) : here).format(ts);
}
